import * as flagrApi from './flagrApi'
import { flags } from './constants'
import { ExperimentFlags, InternalFlags } from './store'

const isExperimentFlag = name => name.startsWith('my-pga-com-exp')

const valueFlag = name => ({ name, init: value => value })
const booleanFlag = name => ({ name, init: value => value === 'true' })

const FLAGS = [
  booleanFlag(flags.FLAG_FEAT_APP_SWITCHER_ENABLED),
  booleanFlag(flags.FLAG_FEAT_JRL_ENABLED),
  booleanFlag(flags.FLAG_FEAT_FC_PROGRAM_TEAMS_ENABLED),
  booleanFlag(flags.FLAG_FEAT_FC_NEW_PAYMENT_SETTINGS_ENABLED),
  booleanFlag(flags.FLAG_FEAT_COACH_DISPLAY_LEAD_MODAL),
  booleanFlag(flags.FLAG_FEAT_COACH_EXCLUSIVE_BOOKING_CAPABILITY),
  booleanFlag(flags.FLAG_FEAT_PAYMENT_ACCOUNT_MANAGEMENT),
  booleanFlag(flags.FLAG_FEAT_RESCHEDULE_LESSON),
  booleanFlag(flags.FLAG_FEAT_REQUEST_TIME),
  booleanFlag(flags.FLAG_FEAT_WEBCAL),
  valueFlag(flags.FLAG_MESSAGING_SERVICE),
  booleanFlag(flags.FLAG_FEAT_ENABLE_ACTIVITY_PLANS),
  booleanFlag(flags.FLAG_FEAT_ENABLE_CUSTOM_PLANS),
  booleanFlag(flags.FLAG_LOCKED_LEADS_ENABLED),
  booleanFlag(flags.FLAG_AVG_RESPONSE_ENABLED),
  valueFlag(flags.FLAG_JRL_GO_LIVE),
  booleanFlag(flags.FLAG_FEAT_JRL_REG_GTM),
  booleanFlag(flags.FLAT_FEAT_STRIPE_FEE_DEDUCTED),
  booleanFlag(flags.FLAG_FEAT_LEAD_INTAKE_STEPPER_FORM),
  booleanFlag(flags.FLAG_EXPEDIED_SHIPPING_DISABLED),
  booleanFlag(flags.FLAG_FEAT_XACT_ENABLE_SHOP_UPSERT),
  booleanFlag(flags.FLAG_FEAT_MESSAGING_ATTACHMENTS),
  booleanFlag(flags.FLAG_FEAT_LESSON_PACKS),
  booleanFlag(flags.FLAG_FEAT_BOOKING_START_TIMES),
  booleanFlag(flags.FLAG_FEAT_IDEAS_PAGE),
  booleanFlag(flags.FLAG_FEAT_EXTERNAL_REGISTRATION),
  booleanFlag(flags.FLAG_FEAT_EXTERNAL_BOOKING_URL),
  booleanFlag(flags.FLAG_FEAT_GROUP_EVENT_ACCESS_CODES),
  booleanFlag(flags.FLAG_FEAT_EVENT_CREATION_REDESIGN),
  booleanFlag(flags.FLAG_FEAT_GROUP_EVENT_RECURRING_PAYMENTS_ENABLED),
  booleanFlag(flags.FLAG_FEAT_SOFT_DELETE_LEADS),
  booleanFlag(flags.FLAG_FEAT_CONVERT_LEAD_TO_STUDENT),
  booleanFlag(flags.FLAG_FEAT_STUDENT_SHOW_PAGE),
  booleanFlag(flags.FLAG_FEAT_COACH_OFFERING_REFRESH),
  booleanFlag(flags.FLAG_STUDENT_DETAILS_SESSIONS),
  booleanFlag(flags.FLAG_STUDENT_MESSAGE_BUTTON),
  booleanFlag(flags.FLAG_STUDENT_REVENUE_STAT),
  booleanFlag(flags.FLAG_FEAT_STUDENT_SHOW_PAGE),
  booleanFlag(flags.FLAG_REFUND_QUICK_ACTION),
  booleanFlag(flags.FLAG_INTERCOM_BUTTON),
  booleanFlag(flags.FLAG_COACH_ONBOARDING),
  booleanFlag(flags.FLAG_FACILITY_OFFERINGS),
  booleanFlag(flags.FLAG_LIGHTNING_FAST_ONBOARDING),
  booleanFlag(flags.FLAG_APP_INSTALL_BANNER_AD),
  booleanFlag(flags.FLAG_FAMILY_GOLF_REBRAND),
  booleanFlag(flags.FLAG_FEAT_COACH_QR_CODE),
  booleanFlag(flags.FLAG_NEW_LEADS_VIEW),
  booleanFlag(flags.FLAG_TIMEZONE_EVENT_BOOKING),
]

const initializeFeatures = async user => {
  // retrieve experiment flag values from previous visits
  // also apply any internal overrides from /ab
  let flagValues = {
    ...ExperimentFlags.get(),
    ...InternalFlags.get(),
  }

  // get the list of active flags for this application
  let activeFlagKeys = new Set()
  try {
    activeFlagKeys = await flagrApi.fetchActiveFlagKeys()

    // perform evaluations for any flags the user has not been evaluated for
    const userFlagKeys = new Set(Object.keys(flagValues))
    const flagKeysToEvaluate = Array.from(activeFlagKeys).filter(
      k => !userFlagKeys.has(k),
    )
    if (flagKeysToEvaluate.length > 0) {
      const flagEvaluations = await flagrApi.evaluateFlags(
        flagKeysToEvaluate,
        user,
      )
      flagValues = {
        ...flagValues,
        ...flagEvaluations,
      }
    }
  } catch (e) {
    window.rg4js &&
      window.rg4js('send', {
        error: e,
        tags: ['flagr'],
      })
  }

  // prune any inactive flags
  flagValues = Object.keys(flagValues)
    .filter(f => activeFlagKeys.has(f))
    .reduce((acc, val) => {
      acc[val] = flagValues[val]
      return acc
    }, {})

  // set the experiment flag cookie for future visits
  if (user != null) {
    const experimentFlagValues = Object.keys(flagValues)
      .filter(f => isExperimentFlag(f))
      .reduce((acc, val) => {
        acc[val] = flagValues[val]
        return acc
      }, {})
    ExperimentFlags.set(experimentFlagValues)
  }

  return FLAGS.reduce(
    (acc, flag) => ({
      ...acc,
      [flag.name]: flag.init(flagValues[flag.name]),
    }),
    {},
  )
}

export default initializeFeatures
